import FormValidator from '@/js/plugins/formValidator';
import { setAlert } from '@/js/_components/head-alert';

const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
const main = () => {
    if (document.querySelector('#page-home') == null) return;
    const formValidatorSettings = {
        renderAreaSelector: '#pre-registration1',
        renderErrorCnt: false,
        renderConfirmMessage: true,
        renderErrorPosition: 'outer',
        submitAction: async (formObj, formValues, event, obj) => {
            const btnObj = formObj.querySelector('button[type="submit"]');
            document.querySelector('body > .c-head-alert')?.remove();
            event.preventDefault();
            const fd = new FormData();
            fd.append('email', formValues.email);
            btnObj.classList.add('is-loading');
            const params = {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': token,
                },
                body: fd,
            }
            const path = formObj.getAttribute('action')
            const resp = await fetch(path, params)
            const data = await resp.json()
            formObj.querySelectorAll('.error-message').forEach((errorDom) => {
                errorDom.remove();
            });
            btnObj.classList.remove('is-loading');
            if('error' in data){
                setAlert(data.error.message, 'error');
            }else if('status' in data && data.status == 'success'){
                formObj.reset();
                setAlert('事前登録を受け付けました。', 'success');
            }
            return false;
        }
    }
    const formValidator1 = new FormValidator(
        {
            ...formValidatorSettings,
            renderAreaSelector: '#pre-registration1'
        }
    )
    const formValidator2 = new FormValidator(
        {
            ...formValidatorSettings,
            renderAreaSelector: '#pre-registration2'
        }
    )
}

export default main;
